import { Grid, withStyles } from "@material-ui/core";
import React from "react";
import styles from "../styles";

const Detail = ({ classes, title, value, xs = 4 }) => {
  return (
    <Grid item xs={xs} className={classes.rightPanelInfoSection}>
      <div className={classes.infoTitle}>{title}</div>
      <div className={`${classes.infoValue} ${classes.infoPadding}`}>
        {value ? value : ""}
      </div>
    </Grid>
  );
};

export default withStyles(styles)(Detail);
